import React from 'react';
import { Box, Text, xcss } from '@atlaskit/primitives';
import VisuallyHidden from '@atlaskit/visually-hidden';
var containerStyles = xcss({
  display: 'flex',
  position: 'relative'
});
export default function renderEllipsis(_ref) {
  var key = _ref.key,
    testId = _ref.testId,
    from = _ref.from,
    to = _ref.to;
  return /*#__PURE__*/React.createElement(Box, {
    as: "li",
    testId: testId,
    key: key,
    xcss: containerStyles,
    paddingInline: "space.100"
  }, /*#__PURE__*/React.createElement(Text, {
    testId: testId && "".concat(testId, "-text")
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, "Skipped pages from ", from, " to ", to), "\u2026"));
}